// Secondary photos are requested only after desktop hover, arrow, or horizontal swipe intent.
(() => {
  if(window.ssApparelPhotoGalleryInstalled)return;
  window.ssApparelPhotoGalleryInstalled=true;
  const initialized=new WeakSet();
  const initialize=root=>root.querySelectorAll('[data-ss-photo-gallery]').forEach(wrap=>{
    if(initialized.has(wrap))return;initialized.add(wrap);
    const urls=JSON.parse(wrap.dataset.ssPhotoGallery);
    const link=wrap.querySelector('.v2-product-photo'),image=link.querySelector('img');
    const prev=wrap.querySelector('.ss-photo-prev'),next=wrap.querySelector('.ss-photo-next'),status=wrap.querySelector('.ss-photo-count');
    const original={src:image.getAttribute('src'),srcset:image.getAttribute('srcset')};
    const loaded=new Map();
    let index=0,busy=false,start=null,suppress=false,incoming=null;
    const load=i=>{
      if(!loaded.has(i))loaded.set(i,new Promise((resolve,reject)=>{
        const photo=new Image();photo.decoding='async';
        photo.onload=()=>resolve(photo);photo.onerror=()=>{loaded.delete(i);reject(new Error('Photo unavailable'));};
        const url=new URL(urls[i],location.href);
        const wanted=Math.ceil(link.getBoundingClientRect().width*Math.min(devicePixelRatio,2));
        url.searchParams.set('width',[240,360,480,700].find(w=>w>=wanted)||700);photo.src=url.href;
      }));
      return loaded.get(i);
    };
    const desktopHover=matchMedia('(hover: hover) and (pointer: fine)');
    let hovering=false,hoverVersion=0,previewing=false;
    const restoreHover=()=>{
      hovering=false;hoverVersion++;
      if(previewing){image.src=original.src;if(original.srcset)image.setAttribute('srcset',original.srcset);previewing=false;}
    };
    wrap.addEventListener('pointerenter',async e=>{
      if(e.pointerType!=='mouse'||!desktopHover.matches||busy||index!==0||wrap.classList.contains('has-browsed'))return;
      hovering=true;const version=++hoverVersion;
      try{
        const photo=await load(1);
        if(!hovering||version!==hoverVersion||busy||index!==0||wrap.classList.contains('has-browsed'))return;
        image.removeAttribute('srcset');image.src=photo.src;previewing=true;
      }catch{/* Leave the original photo visible when the preview fails. */}
    });
    wrap.addEventListener('pointerleave',restoreHover);
    const update=()=>{prev.disabled=index===0;next.disabled=index===urls.length-1;wrap.dataset.index=index;status.textContent=`${index+1} / ${urls.length}`;};
    const getPhoto=async target=>target===0?original:load(target);
    const reset=()=>{if(incoming)incoming.remove();incoming=null;image.style.removeProperty('transform');wrap.classList.remove('is-dragging');};
    const prepare=photo=>{
      if(incoming)incoming.remove();
      incoming=image.cloneNode(false);incoming.removeAttribute('srcset');incoming.src=photo.src;
      incoming.classList.add('ss-photo-incoming');incoming.alt='';incoming.setAttribute('aria-hidden','true');
      link.append(incoming);
    };
    const drag=(dx,step)=>{
      if(!incoming)return;
      const width=link.getBoundingClientRect().width,bounded=Math.max(-width,Math.min(width,dx));
      image.style.transform=`translate3d(${bounded}px,0,0)`;
      incoming.style.transform=`translate3d(${bounded+step*width}px,0,0)`;
    };
    const show=async(step,gesture)=>{
      const target=index+step;
      if(busy)return;
      if(target<0||target>=urls.length){reset();return;}
      const fromHover=previewing&&index===0&&step===2;
      const direction=Math.sign(step);
      // The hover already showed photo two; keep it visible while advancing to three.
      if(fromHover)previewing=false;
      restoreHover();busy=true;wrap.classList.add('is-loading');status.textContent='Loading...';
      let outgoing,arriving;
      try{
        const photo=await getPhoto(target);
        const width=link.getBoundingClientRect().width;
        const from=incoming&&gesture?Math.max(-width,Math.min(width,gesture.dx)):0;
        if(!incoming)prepare(photo);
        wrap.classList.add('is-dragging');drag(from,direction);
        const options={duration:matchMedia('(prefers-reduced-motion: reduce)').matches?0:220,easing:'cubic-bezier(.2,.75,.25,1)',fill:'forwards'};
        outgoing=image.animate([{transform:`translate3d(${from}px,0,0)`},{transform:`translate3d(${-direction*width}px,0,0)`}],options);
        arriving=incoming.animate([{transform:`translate3d(${from+direction*width}px,0,0)`},{transform:'translate3d(0,0,0)'}],options);
        await Promise.all([outgoing.finished,arriving.finished]);
        image.removeAttribute('srcset');image.src=photo.src;
        if(target===0&&original.srcset)image.setAttribute('srcset',original.srcset);
        index=target;wrap.classList.add('has-browsed');
        // Preload just one adjacent photo after browsing, never on page load.
        if(index+1<urls.length)load(index+1).catch(()=>{});
      }catch{if(fromHover){image.src=original.src;if(original.srcset)image.setAttribute('srcset',original.srcset);}}
      finally{reset();outgoing?.cancel();arriving?.cancel();busy=false;wrap.classList.remove('is-loading');update();}
    };
    prev.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();show(-1);});
    next.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();show(desktopHover.matches&&previewing&&index===0&&urls.length>2?2:1);});
    link.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'&&!busy)start={x:e.clientX,y:e.clientY,dx:0,step:0};});
    link.addEventListener('pointermove',e=>{
      if(!start||busy)return;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;
      if(!start.step&&Math.abs(dy)>10&&Math.abs(dy)>Math.abs(dx)){start=null;return;}
      if(Math.abs(dx)<=10||Math.abs(dx)<=Math.abs(dy)*1.5)return;
      const step=dx<0?1:-1,target=index+step;
      if(target<0||target>=urls.length)return;
      start.dx=dx;
      if(start.step!==step){
        start.step=step;reset();const gesture=start;
        getPhoto(target).then(photo=>{if(start===gesture&&start.step===step&&!busy){prepare(photo);wrap.classList.add('is-dragging');drag(start.dx,step);}}).catch(()=>{});
      }
      drag(dx,step);
    });
    link.addEventListener('pointerup',e=>{
      if(!start)return;
      const gesture=start,dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;
      if(gesture.step||Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)*1.5){
        suppress=true;
        if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)*1.5)show(dx<0?1:-1,gesture);else reset();
        setTimeout(()=>{suppress=false;},400);
      }
    });
    link.addEventListener('pointercancel',()=>{start=null;if(!busy)reset();});
    link.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopImmediatePropagation();suppress=false;}},true);
    update();
  });
  initialize(document);
  const grid=document.getElementById('CollectionAjaxContent')||document.getElementById('MainContent');
  if(grid){let pending=false;new MutationObserver(records=>{
    if(pending||!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-ss-photo-gallery]')||n.querySelector('[data-ss-photo-gallery]')))))return;
    pending=true;requestAnimationFrame(()=>{pending=false;initialize(grid);});
  }).observe(grid,{childList:true,subtree:true});}
})();
